import React, { useEffect, useState } from "react";
import MainBox from "./GeneralTab/MainBox/MainBox";
import MembershipCategory from "./GeneralTab/MembershipCategory";
import DataAdminGT from "./GeneralTab/DataAdmin";
import { getDataAdminByFirm } from "../../Services/DataAdmin";
import {
  countAttorneyByFirm,
  fetchPersonByFirm,
  countAttorneyByMainOffice,
} from "../../Services/Person";
import FirmContactGT from "./GeneralTab/FirmContact";
import { getFirmContactByFirmId } from "../../Services/FirmContact";
import MemberMainContactGT from "./GeneralTab/MemberMainContactGT";
import { getMemberMainContact } from "../../Services/MemberMainContact";
import {
  getOffice,
  getOfficeByJurisdiction,
  getOfficeByJurisdictionGroup,
} from "../../Services/Office";
import NotesGT from "./GeneralTab/Notes";
import { getAllFirmNote } from "../../Services/FirmNote";
import { getUsers } from "../../Services/User";
import { useDispatch, useSelector } from "react-redux";
import { Appstore, manageFirmSlice } from "../../redux";
import { hideLoader, showLoader } from "../../redux/loaderActions";
import { getFirmById, getOfficesByFirmId } from "../../Services/Firm";
import {
  findMainOffice,
  resolveFirmPrimaryProfessionals,
  resolveFirmTotalProfessionals,
} from "../../utils/firmProfessionalCounts";

const ManageFirmGeneralTab: React.FC = () => {
  const [dataAdminList, setDataAdminList] = useState<any[]>([]);
  const [personList, setPersonList] = useState<any[]>([]);
  const [wsgWorldwide, setWsgWorldwide] = useState("0");
  const [wsgInJur, setWsgInJur] = useState("0");
  const [offices, setOffices] = useState<any[]>([]);
  const [firmNotes, setFirmNotes] = useState<any[]>([]);
  const [firmContact, setFirmContact] = useState<any>([]);
  const [memberMainContact, setMemberMainContact] = useState<any>([]);
  const [users, setUsers] = useState<any[]>([]);
  const manageFirm = useSelector((state: Appstore) => state.manageFirm);
  const dispatch = useDispatch();
  const [key, setKey] = useState(0);

  useEffect(() => {
    fetchData();
  }, [manageFirm.selectedFirm]);

  useEffect(() => {
    fetchFirm();
  }, []);

  const fetchData = async () => {
    try {
      await Promise.all([
        fetchDataAdmin(),
        fetchUsers(),
        fetchPerson(),
        fetchFirmContact(),
        fetchOffices(),
        fetchMemberMainContact(),
        fetchFirmNote(),
      ]);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchFirm = async () => {
    if (!manageFirm?.selectedFirm) {
      return;
    }
    showLoader();

    const firm = await getFirmById(manageFirm.selectedFirm.id);
    dispatch(manageFirmSlice.actions.SetFirm(firm));

    const offices = await getOfficesByFirmId(firm.id);
    const mainOffice = findMainOffice(offices);
    const worldwide = resolveFirmTotalProfessionals(firm);
    const primary = resolveFirmPrimaryProfessionals(firm, mainOffice);

    localStorage.setItem("firmCountWorldwide", worldwide);
    localStorage.setItem("firmCountPrimary", primary);
    localStorage.setItem("totalProfessionals", worldwide);
    setKey(key + 1);
    hideLoader();
  };

  const fetchDataAdmin = async () => {
    if (!manageFirm.selectedFirm) {
      return;
    }
    const data = await getDataAdminByFirm(manageFirm.selectedFirm.id);
    setDataAdminList(data);
  };

  const fetchUsers = async () => {
    const data = await getUsers();
    setUsers(data);
  };

  const fetchPerson = async () => {
    if (!manageFirm.selectedFirm) {
      return;
    }
    const data = await fetchPersonByFirm(manageFirm.selectedFirm.id);
    setPersonList(data);
  };

  const fetchFirmContact = async () => {
    if (!manageFirm.selectedFirm?.id) {
      return;
    }
    try {
      const data = await getFirmContactByFirmId(manageFirm.selectedFirm.id);
      const firmContactList = Array.isArray(data) ? data : data ? [data] : [];
      setFirmContact(firmContactList);
    } catch {
      setFirmContact([]);
    }
  };

  const fetchOffices = async () => {
    const data = await getOffice();
    setOffices(data);
  };

  const fetchMemberMainContact = async () => {
    const data = await getMemberMainContact();
    const memberMainContactList = data.filter(
      (memberMainContact: any) =>
        memberMainContact.firm === manageFirm.selectedFirm?.id,
    );
    setMemberMainContact(memberMainContactList);
  };

  const fetchFirmNote = async () => {
    const data = await getAllFirmNote();
    const firmNoteList = data.filter(
      (firmNote: any) => firmNote.firm === manageFirm.selectedFirm?.id,
    );
    setFirmNotes(firmNoteList);
  };

  const getWSGDatabaseProfessionals = async () => {
    if (!manageFirm.selectedFirm) {
      return;
    }

    try {
      let peopleColunt = 0;
      if (manageFirm.selectedFirm?.membershipType === "Primary") {
        if (!manageFirm.selectedFirm?.jurisdiction) {
          return;
        }

        const officesInJurisdiction = await getOfficeByJurisdiction(
          manageFirm.selectedFirm.jurisdiction,
        );
        peopleColunt = await countAttorneyByMainOffice(
          officesInJurisdiction.map((office: any) => office.id),
          manageFirm.selectedFirm.id,
        );
      } else {
        if (!manageFirm.selectedFirm?.jurisdictionGroup) {
          return;
        }

        const officesInJurisdiction = await getOfficeByJurisdictionGroup(
          manageFirm.selectedFirm.jurisdictionGroup,
        );
        peopleColunt = await countAttorneyByMainOffice(
          officesInJurisdiction.map((office: any) => office.id),
          manageFirm.selectedFirm.id,
        );
      }
      setWsgInJur(peopleColunt?.toString());
    } catch (error) {
      console.error(error);
    }
  };

  const getWSGDatabaseWorldide = async () => {
    if (!manageFirm.selectedFirm) {
      return;
    }
    const peopleColunt = await countAttorneyByFirm(manageFirm.selectedFirm.id);
    setWsgWorldwide(peopleColunt);
  };

  useEffect(() => {
    getWSGDatabaseWorldide();
    getWSGDatabaseProfessionals();
  }, []);

  return (
    <>
      <div className="flex flex-col gap-10 justify-end">
        <MainBox key={key} />

        <MembershipCategory
          professionalsInPrimary={wsgInJur ?? "0"}
          professionalsWorldwide={wsgWorldwide ?? "0"}
          jurisdictionData={[]}
        />

        <DataAdminGT
          dataAdminList={dataAdminList}
          personList={personList}
          jurisdictionList={[]}
          users={users}
        />

        <FirmContactGT
          firmContactList={firmContact}
          personList={personList}
          jurisdictionList={[]}
        />

        <MemberMainContactGT
          memberMainContactList={memberMainContact}
          personList={personList}
          officeList={offices}
        />

        <NotesGT noteList={firmNotes} id={manageFirm.selectedFirm?.id ?? ""} />
      </div>
    </>
  );
};

export default ManageFirmGeneralTab;
